import { type LoaderFunctionArgs, redirect } from "react-router-dom";

export const controlResultLoader = async ({
  params,
  request,
}: LoaderFunctionArgs) => {
  const controlId = params.controlId;
  if (!controlId || controlId.trim() === "") {
    throw redirect("/controls");
  }

  return { controlId };
};
